export const DARWIN_AVATAR_SIZE = {
    TOGGLE: 28,
    HEADER: 44,
    EMPTY_STATE: 148,
} as const;

export const DARWIN_EMPTY_STATE_AVATAR_PADDING = 28;

export const DARWIN_AVATAR_LAYOUT_ID = "darwin-chat-avatar";

export const DARWIN_AVATAR_LAYOUT_TRANSITION = {
    type: "spring",
    stiffness: 320,
    damping: 30,
    mass: 0.9,
} as const;

export const DARWIN_AVATAR_COLOR = {
    LIGHT: "#08090b",
    DARK: "#f4f4f5",
} as const;

export const DARWIN_AVATAR_EYE_COLOR = {
    LIGHT: "#ffffff",
    DARK: "#08090b",
} as const;

export const DARWIN_AVATAR_AUTO_SLEEP_MS = "0";

export const RIGHT_SIDEBAR_WIDTH = "28rem";
/** The Darwin panel can be dragged wider, up to this share of the window */
export const RIGHT_SIDEBAR_MAX_WIDTH_VW = 40;
export const RIGHT_SIDEBAR_RESIZE_KEYBOARD_STEP_PX = 32;
export const RIGHT_SIDEBAR_WIDTH_CLASS = "darwin-right-sidebar";

// AI Input TypeWriter Placeholders
export const AI_INPUT_TYPEWRITER_PLACEHOLDERS = [
    "How much does a hair transplant at Elithair cost?",
    "How long does a hair transplant take?",
    "What is the success rate of a hair transplant at Elithair?",
    "What is the recovery time after a hair transplant?",
    "What is the best time to get a hair transplant?",
    "Who is Dr. Balwi?",
    "When was Elithair founded?",
    "Where is Elit Klinik located?",
    "Can the Patient get a free consultation?",
    "What is the payment plan?",
    "How big is the Elit Klinik?",
    "How many patients does Elithair serve?",
    "How many hair transplants does Elithair perform?",
] as const;

export const AI_INPUT_TYPEWRITER_TYPE_SPEED_MS = 45;
export const AI_INPUT_TYPEWRITER_DELETE_SPEED_MS = 25;
export const AI_INPUT_TYPEWRITER_DELAY_SPEED_MS = 1800;

export const CHAT_INPUT_MIN_HEIGHT_PX = 44;
export const CHAT_INPUT_TYPEWRITER_MIN_HEIGHT_PX = 72;
export const CHAT_INPUT_MAX_HEIGHT_PX = 120;
